import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Message } from '@domain/models';

@Component({
  selector: 'app-payment-result-date-expired',
  templateUrl: './payment-result-date-expired.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentDateExpiredResultComponent {
  readonly message = input.required<Message>();
}
